// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Animation_skeleton__tGRR_","shimmer":"Animation_shimmer__cZ_w_"};